import { MarketChartsCategories } from '@/interfaces/storageForecasting/IRunOutput.ts';
import { RouteRecordRaw } from 'vue-router';

export const systemForecastRoutes: Record<string, RouteRecordRaw> = {
    general: {
        path: 'general',
        name: 'systemForecastsGeneral',
        component: () => import('@/views/storageForecasting/MarketAssumptionsView.vue'),
        props: { marketChartsCategory: MarketChartsCategories.SystemForecasts },
        meta: {
            headName: 'General',
            pageNeedsLoader: true,
            accessName: 'marketAssumptions',
            searchMeta: {
                tags: ['battery', 'BESS', 'storage', 'market', 'assumptions', 'price', 'power', 'forecasts', 'curves'],
            },
        },
    },
    capacityMarket: {
        path: 'capacity-market',
        name: 'capacityMarket',
        component: () => import('@/views/storageForecasting/MarketAssumptionsView.vue'),
        props: { marketChartsCategory: MarketChartsCategories.CapacityMarket },
        meta: {
            headName: 'Capacity Market',
            pageNeedsLoader: true,
            accessName: 'capacityMarket',
            searchMeta: {
                tags: ['battery', 'BESS', 'storage', 'market', 'assumptions', 'price', 'power', 'forecasts', 'curves'],
            },
        },
    },
    tnuos: {
        path: 'tnuos',
        name: 'tnuos',
        component: () => import('@/views/storageForecasting/MarketAssumptionsView.vue'),
        props: { marketChartsCategory: MarketChartsCategories.TNUoS },
        meta: {
            headName: 'TNUoS',
            pageNeedsLoader: true,
            accessName: 'tnuos',
            searchMeta: {
                tags: ['battery', 'BESS', 'storage', 'market', 'assumptions', 'price', 'power', 'forecasts', 'curves'],
            },
        },
    },
    tlm: {
        path: 'tlm',
        name: 'tlm',
        component: () => import('@/views/storageForecasting/MarketAssumptionsView.vue'),
        props: { marketChartsCategory: MarketChartsCategories.TLMs },
        meta: {
            headName: 'TLMs',
            pageNeedsLoader: true,
            accessName: 'tlms',
            searchMeta: {
                tags: ['battery', 'BESS', 'storage', 'market', 'assumptions', 'price', 'power', 'forecasts', 'curves'],
            },
        },
    },
};

export const forecastsRoutes: Record<string, RouteRecordRaw> = {
    redirect: {
        path: '',
        name: 'forecastsRedirect',
        redirect: { name: 'storageAssets' },
        meta: {
            headName: 'Forecasts Redirect',
        },
    },
    assets: {
        path: 'assets',
        name: 'storageAssets',
        component: () => import('@/views/storageForecasting/AssetsView.vue'),
        meta: {
            headName: 'Assets',
            pageNeedsLoader: true,
            accessName: 'assets',
            searchMeta: {
                tags: ['battery', 'BESS', 'storage', 'assets', 'workspace', 'forecasts'],
            },
        },
    },
    systemAssumptions: {
        path: 'system-assumptions',
        name: 'systemAssumptions',
        component: () => import('@/views/storageForecasting/MarketAssumptionsView.vue'),
        props: { marketChartsCategory: MarketChartsCategories.SystemAssumptions },
        meta: {
            headName: 'System Assumptions',
            pageNeedsLoader: true,
            accessName: 'marketAssumptions',
            searchMeta: {
                tags: ['battery', 'BESS', 'storage', 'market', 'assumptions', 'price', 'power', 'forecasts', 'curves'],
            },
        },
    },
    systemForecasts: {
        path: 'system-forecasts',
        name: 'systemForecasts',
        meta: {
            headName: 'System Forecasts',
            pageNeedsLoader: true,
            accessName: 'marketAssumptions',
            searchMeta: {
                tags: ['battery', 'BESS', 'storage', 'market', 'assumptions', 'price', 'power', 'forecasts', 'curves'],
            },
        },
        children: Object.values(systemForecastRoutes),
    },
    report: {
        path: 'report',
        name: 'forecastReport',
        component: () => import('@/views/storageForecasting/ReportView.vue'),
        meta: {
            headName: 'Report',
            accessName: 'forecastReport',
            searchMeta: {
                tags: ['battery', 'BESS', 'storage', 'revenue', 'forecasts'],
            },
        },
    },
};
